const ACTIVE_STATUSES = new Set([
    "SETUP_TASK",
    "PENDING",
    "GENERATING_MESSAGE",
    "IN_PROGRESS",
    "PROCESSING",
    "FILE_PROCESSING",
    "READY_TO_CALCULATE",
    "CALCULATING",
    "REPORT_IN_PROGRESS",
    "NOTIFICATION_IN_PROGRESS",
])

const STATUS_PRESENTATION = {
    SETUP_TASK: ["Preparando", "primary"],
    PENDING: ["Pendente", "warning"],
    GENERATING_MESSAGE: ["Preparando mensagens", "primary"],
    IN_PROGRESS: ["Em progresso", "primary"],
    PROCESSING: ["Processando", "primary"],
    FILE_PROCESSING: ["Processando arquivo", "primary"],
    EXCEEDED_RETRIES: ["Retentativas excedidas", "error"],
    PROCESS_DONE: ["Concluído", "success"],
    ERROR: ["Erro", "error"],
    READY_TO_CALCULATE: ["Pronto para calcular", "primary"],
    CALCULATING: ["Calculando", "primary"],
    CALCULATE_DONE: ["Calculado", "success"],
    REPORT_IN_PROGRESS: ["Gerando relatório", "primary"],
    REPORT_DONE: ["Relatório concluído", "success"],
    NOTIFICATION_IN_PROGRESS: ["Enviando notificação", "primary"],
    NOTIFICATION_DONE: ["Notificação concluída", "success"],
}

export const safeJsonObject = (value) => {
    if (value && typeof value === "object" && !Array.isArray(value)) return value
    if (typeof value !== "string" || !value.trim()) return {}
    try {
        const parsed = JSON.parse(value)
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {}
    } catch (_) {
        return {}
    }
}

export const clampProgress = (value) => {
    const numeric = Number(value)
    if (!Number.isFinite(numeric)) return 0
    return Math.min(100, Math.max(0, numeric))
}

export const normalizeWorkflowExecution = (execution = {}) => {
    const metadataInput = safeJsonObject(execution.metadata_input ?? execution.metadata)
    const progressTotal = Math.max(0, Number(execution.progress_total ?? execution.total_registros ?? 0) || 0)
    const progressProcessed = Math.max(
        0,
        Number(execution.progress_processed ?? execution.total_registros_processados ?? 0) || 0
    )
    const calculatedPercent = progressTotal > 0 ? (progressProcessed * 100) / progressTotal : 0
    const contractVersion = execution.contract_version || "v1"

    return {
        ...execution,
        id: execution.id,
        dag_id: execution.dag_id || execution.rotina || "",
        run_id: execution.run_id || execution.external_workflow_id || null,
        contract_version: contractVersion,
        workflow_group: execution.workflow_group || execution.rotina_grupo || null,
        reference_date:
            execution.reference_date || execution.data_referencia || metadataInput.data_referencia || null,
        current_stage: execution.current_stage || execution.etapa_atual || null,
        progress_total: progressTotal,
        progress_processed: Math.min(progressProcessed, progressTotal || progressProcessed),
        progress_percent: clampProgress(execution.progress_percent ?? calculatedPercent),
        heartbeat_at: execution.heartbeat_at || execution.heartbeat_em || null,
        created_by: execution.created_by ?? execution.criado_por ?? null,
        created_by_name: execution.created_by_name || execution.nome_usuario || null,
        metadata_input: metadataInput,
        metadata_output: safeJsonObject(execution.metadata_output),
        current_error: execution.current_error || null,
        created_at: execution.created_at || execution.criado_em || null,
        updated_at: execution.updated_at || execution.atualizado_em || null,
        capabilities: execution.capabilities || {
            detailed_progress: contractVersion === "v2",
            structured_errors: contractVersion === "v2",
            legacy_report: Boolean(execution.report_path),
        },
        stages: Array.isArray(execution.stages) ? execution.stages : [],
        errors: Array.isArray(execution.errors) ? execution.errors : [],
    }
}

export const isWorkflowActive = (execution) => ACTIVE_STATUSES.has(execution?.status)

export const shouldPollWorkflows = (executions, drawerOpen, visibilityState = "visible") =>
    visibilityState === "visible" && (Boolean(drawerOpen) || executions.some(isWorkflowActive))

export const workflowStatusPresentation = (status) => {
    const [text, color] = STATUS_PRESENTATION[status] || [status || "Não informado", "default"]
    return {text, color}
}
